export default __webpack_public_path__ + "static/media/microFocus.cce51aaf.png";